import Cookies from "js-cookie";

function WUserInfo() {
    this._listeners = [];
    this._userInfo = undefined;
    this._loading = true;

    var USER_INFO_COOKIE = "_w0aun_";
    var USER_KEY_COOKIE = "user";

    this._notifyListeners = function () {
        var _this = this;
        _this._listeners.map((listener) => listener.callback(_this._userInfo));
        _this._loading = false;
    };

    this._getInfoCookie = function () {
        return Cookies.get(USER_INFO_COOKIE);
    };

    this._displayUserInfo = function () {
        let firstName = this._userInfo.firstName.replace("+", " ");
        let lastName = this._userInfo.lastName.replace("+", " ");

        if (this._userInfo.avatarUrl) {
            $("#user-info__avatar__label").hide();
            $("#user-panel__head__avatar__label").hide();
            if (this._userInfo.avatarUrl) {
                $("#user-info__avatar__img").attr(
                    "src",
                    this._userInfo.avatarUrl
                );
                $("#user-panel__head__avatar__img").attr(
                    "src",
                    this._userInfo.avatarUrl
                );
                $(".user-panel__head__avatar").removeClass(
                    "user-panel__head__avatar--no-avatar"
                );
            }
        } else {
            $("#user-info__avatar__img").hide();
            $("#user-panel__head__avatar__img").hide();
            $("#user-info__avatar__label").text(
                firstName.charAt(0) + lastName.charAt(0)
            );
            $("#user-panel__head__avatar__label").text(
                firstName.charAt(0) + lastName.charAt(0)
            );
        }

        $("#mobile-menu-user-link").addClass("mobile-menu-user-link--logged");
        $("#mobile-menu-user-name").text(firstName + " " + lastName);

        $("#user-panel__name").text(firstName + " " + lastName);
        $("#user-info__wrapper__name").text(firstName + " " + lastName);

        $("#subscribe").removeClass("subscribe--visible");
        $("#user-info").addClass("user-info--visible");
        this._userInfo.pwa === "true"
            ? $("body").removeClass("unsubscribed")
            : $("body").addClass("unsubscribed");
        if (window.reloadSalesTouchPoints) {
            window.reloadSalesTouchPoints(this._userInfo);
        }

        // Add user id and type into GTM
        if (window.dataLayer) {
            window.dataLayer.push({ visitor_type: "SsoUser" });
            window.dataLayer.push({ pwa: this._userInfo.pwa });
        }
    };

    this._displayLoginLink = function () {
        if (window.dataLayer) {
            if (Cookies.get("wtss")) {
                //Check if the test user(one-article-test) exists
                window.dataLayer.push({ visitor_type: "TestUser" });
            } else {
                window.dataLayer.push({ visitor_type: "Anonymous" });
            }
        }

        $("#mobile-menu-user-link").addClass("mobile-menu-user-link--unlogged");
        $("#subscribe").addClass("subscribe--visible");
        $("#user-info").removeClass("user-info--visible");
    };

    this._tryParseAndDisplayUserInfo = function () {
        var infoCookie = this._getInfoCookie();
        if (!infoCookie) {
            this._displayLoginLink();
            this._notifyListeners();
            $("body").addClass("unsubscribed");
            window.reloadSalesTouchPoints && window.reloadSalesTouchPoints();
            return;
        }

        try {
            this._userInfo = JSON.parse(
                infoCookie.replace(`${USER_KEY_COOKIE}=`, "")
            );
            this._displayUserInfo();
        } catch (e) {
            // Fallback to display login button if we cannot parse user cookie (can occurs with old cookie)
            this._displayLoginLink();
            $("body").addClass("unsubscribed");
            window.reloadSalesTouchPoints && window.reloadSalesTouchPoints();
        } finally {
            this._notifyListeners();
        }
    };

    /**
     *   Public functions
     */

    this.getUserInfo = function () {
        var _this = this;
        // Get user's cookie to display/hide login and logout links
        var userInfoCookie = _this._getInfoCookie();

        if (!userInfoCookie) {
            // Check if user is "really" not logged by getting his information from the backend
            // We need to perform this call in case of cache page. If the page is cache and the user logged,
            // we still see "login", which is wrong.
            $.ajax({
                type: "GET",
                url: "/oauth/userInfo",
            }).always(function () {
                _this._tryParseAndDisplayUserInfo();
            });
        } else {
            _this._tryParseAndDisplayUserInfo();
        }
    };

    this.addListener = function (name, callback) {
        if (this._listeners.find((listener) => listener.name === name)) {
            return;
        }
        this._listeners.push({ name: name, callback: callback });

        if (!this._loading) {
            callback(this._userInfo);
        }
    };
}

document.WUserInfo = new WUserInfo();

export default document.WUserInfo;



// WEBPACK FOOTER //
// ./js/user-cookie.js